import React, { useState } from "react";
import { useGlobalContext } from "../../context";
import "../../styles/experience.scss";

import { motion } from "framer-motion";

import { Badge } from "../ui/badge";
import { LayoutContainer } from "../common";
import { Button } from "../ui";
import { Card, CardContent } from "../ui/card";
import { Separator } from "../ui/separator";

/*
todo : add correct data for experience
todo : add translation for that data 
todo : add recommendations if they existe 
todo : add responsivness (For now it will show only on WEB)
todo : add Mobile projects 
todo : add recomondations for each company and it should shows as a popup and PDF


 Designed and developed user interfaces using React, following best practices and adhering to coding standards.
• Collaborated with designers and back-end developers to create and implement responsive and interactive user interfaces.
• Utilized React hooks and functional components to build reusable and maintainable code
• Optimized web pages for maximum speed and scalability by implementing techniques such as code splitting and lazy loading.
• Troubleshot and debugged web applications, using React developer tools and identifying and resolving issues in a timely manner.
• Stayed up-to-date with new React technologies and trends, evaluating and incorporating new features and libraries when appropriate.
• Worked closely with the development team to ensure seamless integration of the front-end and back-end systems.
• Collaborated with the product and design teams to understand user requirements and design needs.
• Collaborated with other team members to develop and implement new features.
• Participated in Scrum meetings and contributed to the sprint planning process, by providing input on task estimates and identifying dependencies.

*/

const EXPERIENCE_DATA = {
  Nassej: {
    company: "Nassej",
    title: "Nassej_job_title",
    companyLink: "www.google.com",
    period: "January 2022 - Present",
    roles: ["Nassej_des_1", "Nassej_des_2"],
    techStack: ["React", "React Native", "Expo", "Less", "Native Base"],
  },
  Keeneye: {
    company: "Keeneye",
    title: "Keeneye_job_title",
    companyLink: "www.google.com",
    period: "May 2021 - January 2022",
    roles: ["Keeneye_des_1", "Keeneye_des_2"],
    techStack: ["React", "React Native"],
  },
  Timgado: {
    company: "Timgado",
    title: "Timgado_job_title",
    companyLink: "www.google.com",
    period: "May 2020 - May 2021",
    roles: ["Timgado_des_1", "Timgado_des_2"],
    techStack: [
      "React",
      "React Native",
      "Expo",
      "Sass",
      "Styled Components",
      "TypeScript",
      "Css",
      "Material UI",
      "Figma",
      "Redux",
    ],
  },
  Freelancer: {
    company: "Freenlance",
    title: "Freelancer_job_title",
    companyLink: "www.google.com",
    period: "January 2020 -  May 2020",
    roles: [
      "Freelancer_des_1",
      "Freelancer_des_2",
      "Freelancer_des_3",
      "Freelancer_des_4",
    ],
    techStack: ["HTML", "CSS", "Bootstrap", "Sass", "JavaScript"],
  },
};

export const Experience = () => {
  const [currentCompany, setCurrentCompany] = useState(
    Object.keys(EXPERIENCE_DATA)[0]
  );
  const { t } = useGlobalContext();

  return (
    <LayoutContainer className="min-h-[83vh] flex-1 flex flex-col items-center">
      <motion.div
        initial={{ scaleY: 0 }}
        animate={{ scaleY: 1 }}
        exit={{ scaleY: 0 }}
        transition={{ duration: 0.3 }}
        className="w-full flex-1 flex flex-col items-center justify-center h-[100%]"
      >
        {/* Title Section */}
        <div className="flex  justify-between items-center w-full mb-12 gap-6">
          <h3 className="text-4xl font-bold text-primary whitespace-nowrap">
            {t(`experience.title`)}
          </h3>
          {/* <div className="flex-1 h-[2px] bg-border ml-4"></div> */}
          <Separator className="flex-1 h-[2px] bg-border" />
        </div>
        <div className="flex w-full gap-6">
          {/* Sidebar */}
          <div className="w-1/4 min-w-[220px] bg-background p-4 rounded-xl  flex-shrink-0 border border-border">
            <h4 className="text-lg font-semibold text-primary mb-4">
              {t("Companies")}
            </h4>
            <ul className="space-y-2">
              {Object.keys(EXPERIENCE_DATA).map((name) => (
                <li key={name}>
                  <Button
                    variant={currentCompany === name ? "secondary" : "ghost"}
                    className="w-full px-4 py-2 text-left flex justify-start items-center"
                    onClick={() => setCurrentCompany(name)}
                  >
                    {name}
                  </Button>
                </li>
              ))}
            </ul>
          </div>

          {/* Experience Card */}
          <Card className="flex-1 bg-background  border border-border flex-shrink-0">
            <CardContent className="p-6 h-[400px] w-full overflow-y-auto overflow-x-hidden">
              <DisplayedContent {...EXPERIENCE_DATA[currentCompany]} t={t} />
            </CardContent>
          </Card>
        </div>
      </motion.div>
    </LayoutContainer>
  );
};

const DisplayedContent = ({ company, title, period, roles, techStack, t }) => {
  return (
    <motion.div
      initial={{ y: 10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -10, opacity: 0 }}
      transition={{ duration: 0.4 }}
    >
      <h3 className="text-2xl font-semibold text-primary">
        {t(`experience.${title}`)}
      </h3>
      <p className="text-sm text-muted-foreground mb-4">{period}</p>
      <div className="space-y-3">
        {roles.map((role, idx) => (
          <p key={idx} className="text-foreground text-lg">
            {t(`experience.${role}`)}
          </p>
        ))}
      </div>
      <div className="flex flex-wrap gap-2 mt-4">
        {techStack.map((tech) => (
          <Badge key={tech} variant="secondary" className="px-3 py-1 text-sm">
            {tech}
          </Badge>
        ))}
      </div>
    </motion.div>
  );
};
